import Vue from 'vue';
import { mutationTypes } from '@/types';
import logger from '@/tools/logger';

export default async function loadGlossary({ state, getters, commit }, { language } = {}) {
	if (!state.dataSourceCFG.global.showGlossary) return;
	let url;
	try {
		// get glossary package url
		const glossaryURL = state.dataSourceCFG.offlineAppWithVersionProviderInit.find((element) =>
			/^glossary-/.test(element.name)
		).name;
		url = new URL(`./apps/${glossaryURL}/${language || getters.currentLanguage}.json`, state.dataSourceURL);
		const { body } = await Vue.http.get(url.toString());
		commit(mutationTypes.setGlossary, { glossary: body });
	} catch (error) {
		logger.error(`Could not initialise glossary at ${url}`);
	}
}
